import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';
import PriceTagOrIncluded from '../../../../../../Configurator/components/PriceTagOrIncluded/PriceTagOrIncluded.js';

const ConfigurationSummaryRow = ({ label , value , price , discountText , className ,  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('configuration-summary-row', className),
        "data-t": "configuration-summary-row"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement("strong", {
        className: "configuration-summary-row__label"
    }, label || ''), /*#__PURE__*/ React.createElement("span", {
        className: "configuration-summary-row__value"
    }, value || '')), typeof (price === null || price === void 0 ? void 0 : price.originalPrice) !== 'undefined' && /*#__PURE__*/ React.createElement(PriceTagOrIncluded, swcHelpers.extends({}, price, {
        discountText: discountText
    })));
};
var ConfigurationSummaryRow$1 = ConfigurationSummaryRow;

export { ConfigurationSummaryRow$1 as default };
//# sourceMappingURL=ConfigurationSummaryRow.js.map
